import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

import ExcelFileDrop from "../../components/form/excelFileDrop.comp";
import ExcelFileInput from "../../components/form/excelFileInput.comp";
import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";
import { RootStateContext } from "../../states/root.state";
import { CatImport } from "../../types/category";
import { BrandImport } from "../../types/brand";
import { ProductImport } from "../../types/product";
import MediaDrop from "../../components/form/mediaFileDrop.comp";
import MediaFileInput from "../../components/form/mediaFileInput.comp";

export default function ImportProductPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.import.import)}>
      <Link className="underline" href="/import/shop">
        {t(msg.import.importExportWholeShop)}
      </Link>
      <div>
        <Link className="underline" href="/import/legacy">
          {t(msg.import.importLegacy)}
        </Link>
      </div>
      <ImportProduct />
      <ImportProductImages />
      <ImportCat />
      <ImportBrand />
      <ImportCatAssociate />
    </Layout>
  );
}

const ImportProduct = () => {
  const { t, msg } = useTranslation();
  const [excelData, setExcelData] = useState<ProductImport[] | null>(null);
  const { push } = useRouter();
  const { productImportService } = useContext(RootStateContext);

  useEffect(() => {
    if (!excelData) return;

    productImportService.send({ type: "SELECT_FILE", products: excelData });
    push("/import/product/list");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    productImportService.stop();
    productImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" className="space-y-4">
      <h2>{t(msg.import.importProduct)}</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
};



const ImportCat = () => {
  const [excelData, setExcelData] = useState<CatImport[] | null>(null);
  const { push } = useRouter();
  const { catImportService } = useContext(RootStateContext);
  const { t, msg } = useTranslation();

  useEffect(() => {
    if (!excelData) return;

    catImportService.send({ type: "SELECT_FILE", cats: excelData });
    push("/import/cat/list");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    catImportService.stop();
    catImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" id="import-cat" className="space-y-4">
      <h2>{t(msg.import.importCategory)}</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
};

const ImportProductImages = () => {
  const { push } = useRouter();
  const [data, setData] = useState<any>(null);
  const { productImageImportService } = useContext(RootStateContext);
  const { t, msg } = useTranslation();
  useEffect(() => {
    if (!data) return;

    productImageImportService.send({
      type: "SELECT_FILE",
      files: data,
      filesProgress: [...data].map((f) => ({ name: f, progress: 0 })),
    });
    push("/import/productImage/list");

    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    productImageImportService.stop();
    productImageImportService.start();
    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" className="space-y-4">
      <h2>{t(msg.import.importProductImages)}</h2>
      <MediaDrop setData={setData} />
      <MediaFileInput setData={setData} />
    </section>
  );
};

const ImportBrand = () => {
  const [excelData, setExcelData] = useState<BrandImport[] | null>(null);
  const { push } = useRouter();
  const { brandImportService } = useContext(RootStateContext);
  const { t, msg } = useTranslation();

  useEffect(() => {
    if (!excelData) return;

    brandImportService.send({ type: "SELECT_FILE", brands: excelData });
    push("/import/brand/list");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    brandImportService.stop();
    brandImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" id="import-brand" className="space-y-4">
      <h2>{t(msg.import.importBrand)}</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
};

const ImportCatAssociate = () => {
  const [excelData, setExcelData] = useState<BrandImport[] | null>(null);
  const { push } = useRouter();
  const { productCatAssociateImportService } = useContext(RootStateContext);
  const { t, msg } = useTranslation();

  useEffect(() => {
    if (!excelData) return;

    productCatAssociateImportService.send({ type: "SELECT_FILE", products: excelData });
    push("/import/product/catAssociateList");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    productCatAssociateImportService.stop();
    productCatAssociateImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" id="import-product-cat-associate" className="space-y-4">
      <h2>{t(msg.import.importProductCatAssocation)}</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
};
